module.exports = __webpack_public_path__ + "img/Mask Group@2x.66a39c23.png";